// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3yxma","open":"open___xmFAq","avatar":"avatar___2AvcY","letter":"letter___2Z2H9","small":"small___3oLQ-"};